import styled from '@emotion/styled'
import { Box, TextField, Button } from '@mui/material'
import { typography, colors } from '@resiliatech/birdsong'

export const Container = styled(Box)`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  background-color: ${colors.background.default};
`

export const Header = styled(Box)`
  margin-bottom: 32px;
  
  h4 {
    ${typography.up3.semiBoldSans};
    color: ${colors.copy.headerDark};
    margin-bottom: 8px;
  }
  
  .MuiTypography-body1 {
    ${typography.baseline.regularSans};
    color: ${colors.copy.paragraphDark};
  }
`

export const QuerySection = styled(Box)`
  margin-bottom: 32px;
  padding: 24px;
  border: 1px solid ${colors.interactive.borderEnabledHoverGray};
  border-radius: 8px;
  background-color: ${colors.background.paper};
`

export const QueryInput = styled(TextField)`
  .MuiOutlinedInput-root {
    background-color: ${colors.background.paper};
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.interactive.primaryEnabled};
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.interactive.primaryEnabled};
    }
  }
  
  .MuiInputLabel-root {
    ${typography.baseline.regularSans};
    
    &.Mui-focused {
      color: ${colors.interactive.primaryEnabled};
    }
  }
`

export const ActionButton = styled(Button)`
  ${typography.baseline.semiBoldSans};
  background-color: ${colors.interactive.primaryEnabled};
  color: ${colors.background.paper};
  padding: 12px 24px;
  min-width: 200px;
  
  &:hover {
    background-color: ${colors.interactive.primaryHoverFocus};
  }
  
  &:disabled {
    background-color: ${colors.interactive.disabledDark};
    color: ${colors.interactive.disabledLight};
  }
`

export const ResultsSection = styled(Box)`
  margin-top: 32px;
`

export const ChartContainer = styled(Box)`
  margin-bottom: 32px;
  padding: 24px;
  border: 1px solid ${colors.interactive.borderEnabledHoverGray};
  border-radius: 8px;
  background-color: ${colors.background.paper};
  display: flex;
  flex-direction: column;
  align-items: center;
  
  h6 {
    ${typography.up1.semiBoldSans};
    color: ${colors.copy.headerDark};
    margin-bottom: 16px;
  }
  
  .MuiChartsAxis-root {
    .MuiChartsAxis-tick {
      stroke: ${colors.copy.paragraphDark};
    }
    
    .MuiChartsAxis-label {
      fill: ${colors.copy.paragraphDark};
      ${typography.down1.regularSans};
    }
  }
  
  .MuiChartsLegend-root {
    .MuiChartsLegend-series {
      ${typography.baseline.regularSans};
    }
  }
`

export const TableWrapper = styled(Box)`
  .MuiTableContainer-root {
    border: 1px solid ${colors.interactive.borderEnabledHoverGray};
    border-radius: 8px;
    max-height: 600px;
    overflow-y: auto;
  }
  
  .MuiTableHead-root {
    background-color: ${colors.background.secondaryBackground};
    
    .MuiTableCell-root {
      ${typography.baseline.semiBoldSans};
      background-color: ${colors.background.secondaryBackground};
      border-bottom: 2px solid ${colors.interactive.borderEnabledHoverGray};
      color: ${colors.copy.headerDark};
    }
  }
  
  .MuiTableBody-root {
    .MuiTableRow-root {
      &:nth-of-type(even) {
        background-color: ${colors.background.tertiaryBackground};
      }
      
      &:hover {
        background-color: ${colors.interactive.tableHoverFocus};
      }
    }
    
    .MuiTableCell-root {
      ${typography.baseline.regularSans};
      color: ${colors.copy.paragraphDark};
      border-bottom: 1px solid ${colors.interactive.borderEnabledHoverGray};
    }
  }
`

export const SqlSection = styled(Box)`
  margin-bottom: 24px;
`